import { supabase } from '@/lib/supabase'
import type { Queue } from '../types'

/**
 * Fetch all queues, optionally filtered by profile
 */
export async function getQueues(profileId?: string): Promise<Queue[]> {
    let query = supabase
        .from('queues')
        .select('*')
        .order('name')

    if (profileId) {
        query = query.eq('profile_id', profileId)
    }

    const { data, error } = await query

    if (error) throw error
    return data as Queue[]
}

/**
 * Create a new queue
 */
export async function createQueue(queue: Partial<Queue>): Promise<Queue> {
    const { data, error } = await supabase
        .from('queues')
        .insert({
            ...queue,
            created_at: new Date().toISOString(),
            updated_at: new Date().toISOString()
        })
        .select()
        .single()

    if (error) throw error
    return data as Queue
}

/**
 * Update an existing queue
 */
export async function updateQueue(id: string, updates: Partial<Queue>): Promise<Queue> {
    const { data, error } = await supabase
        .from('queues')
        .update({
            ...updates,
            updated_at: new Date().toISOString()
        })
        .eq('id', id)
        .select()
        .single()

    if (error) throw error
    return data as Queue
}

/**
 * Delete a queue
 */
export async function deleteQueue(id: string): Promise<void> {
    const { error } = await supabase
        .from('queues')
        .delete()
        .eq('id', id)

    if (error) throw error
}
